import React, { createElement } from 'react';

export const passPropsTo = (Component, props) => {
	return class NewComponent extends React.Component {
		render() {
			return createElement(Component, Object.assign({}, this.props, props));
		}
	};
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/component.js